import qs from 'qs'
import SuperagentApi from '../assets/utils/superagent'

const token = Wiz.AuthHooks.GetToken()
const headers = {
  Authorization: `Bearer ${localStorage.getItem('authorization') || token}`,
  'X-Wiz-Tenant-Id': JSON.parse(window.localStorage.getItem('CurrentUser'))?.TenantId || '',
}
const handoverServerConfig = _.get(
  Wiz,
  'globalSettings.dynamicModules.modules["visualization-tongre-vulkan"].config'
).handoverServerConfig
const twoTicketServerConfig = _.get(
  Wiz,
  'globalSettings.dynamicModules.modules["visualization-tongre-vulkan"].config'
).twoTicketServerConfig
const portal = _.get(
  Wiz,
  'globalSettings.dynamicModules.modules["visualization-tongre-vulkan"].config'
).portal
const superagentApi = new SuperagentApi({
  baseUrl: handoverServerConfig.baseUrl
})
const twoTicketApi = new SuperagentApi({
  baseUrl: twoTicketServerConfig?.baseUrl
})
const portalApi = new SuperagentApi({
  baseUrl: portal
})
export default class HandoverService {
  // 获取实体类型动态表头
  static async getClassTypeTableHeader(payload) {
    const [
      err,
      res,
    ] = await superagentApi.get(
      `/api/std/StdClassData/class-type-table-header?${qs.stringify(payload)}`, {
        headers
      }
    )
    return [err, res]
  }
  static async getPersonalityMetaDefine(payload) {
    const [err, res] = await superagentApi.get(
      `/api/std/StdPersonalityMetaData/list?${qs.stringify(payload)}`, {
        headers
      }
    )
    return [err, res]
  }

  // 获取实体属性的个性化属性数据
  static async getPersonalityMetaData(payload) {
    const [
      err,
      res,
    ] = await superagentApi.get(
      `/api/std/StdPersonalityMetaData/getstdpersonalitymetadatavalue-list?${qs.stringify(
        payload
      )}`, {
        headers
      }
    )
    return [err, res]
  }

  // 获取实体分组动态表头
  static async getDynamicTableGroupHeader(payload) {
    const [
      err,
      res,
    ] = await superagentApi.get(
      `/api/std/StdClassData/dynamic-table-group-header?${qs.stringify(payload)}`, {
        headers
      }
    )
    return [err, res]
  }
  // 获取动态表单数据
  static async getDynamicTableData(payload) {
    const [
      err,
      res,
    ] = await superagentApi.get(
      `/api/std/StdClassData/dynamic-table-data-by-id?${qs.stringify(payload)}`, {
        headers
      }
    )
    return [err, res]
  }
  // 获取code的id和classId
  static async getCodeId(payload) {
    const [
      err,
      res,
    ] = await superagentApi.get(
      `/api/std/StdClassData/type-dynamic-table-data-by-id?${qs.stringify(payload)}`, {
        headers
      }
    )
    return [err, res]
  }
  // 获取关联文档
  static async getAssociatedFiles(payload) {
    const [err, res] = await superagentApi.get(
      `/api/std/Tag/associated-files?${qs.stringify(payload)}`, {
        headers,
      }
    )
    return [err, res]
  }
  // 获取上下级对象
  static async getParentAndSubObj(payload) {
    const [err, res] = await superagentApi.get(`/api/std/Tag/associated?${qs.stringify(payload)}`, {
      headers,
    })
    return [err, res]
  }
  // 获取关联对象
  static async getAssociatedTags(params) {
    const [err, res] = await superagentApi.get('/api/std/ObjectAssociation/associated-tags', {
      params,
      headers,
    })
    return [err, res]
  }
  // 获取对象树
  static async getTagTree(data) {
    const [err, res] = await superagentApi.post('/api/std/Tag/get-tag-tree-list', {
      data,
      headers
    })
    return [err, res]
  }
  // 获取对象所有子级编码，包括自己
  static async getTagChildren(payload, standardId) {
    const [err, res] = await superagentApi.get(
      `/api/std/Tag/get-tag-children-code-list?id=${payload}&standardId=${standardId}`, {
        headers,
      }
    )
    return [err, res]
  }
  // 获取文档树
  static async getDocumentTree(params) {
    const [err, res] = await superagentApi.get('/api/std/Document/get-document-tree', {
      params,
      headers,
    })
    return [err, res]
  }
  // 获取文件id
  static async getFileId(payload) {
    const [err, res] = await superagentApi.get(
      `/api/std/Document/get-document-detail?${qs.stringify(payload)}`, {
        headers,
      }
    )
    return [err, res]
  }
  // 获取fileName
  static async getFileName(payload) {
    const [err, res] = await superagentApi.get(`/api/std/Document/single-file/${payload}`, {
      headers,
    })
    return [err, res]
  }
  // 获取模型信息
  static async getModelInfo(payload) {
    const [err, res] = await superagentApi.get(`/api/std/Document/multi_model?id=${payload}`, {
      headers,
    })
    return [err, res]
  }
  // 获取标准库列表
  static async getStandardList() {
    const [err, res] = await superagentApi.get('/api/std/StdStandard', {
      headers,
    })
    return [err, res]
  }
  // 对象树根据code，获取下一级
  static async getTagChildrenByCode(data) {
    const [err, res] = await superagentApi.post('/api/std/Tag/get-tag-children', {
      data,
      headers
    })
    return [err, res]
  }
  // 获取工作票接口
  static async getWorkTicketList(payload, data) {
    const [err, res] = await twoTicketApi.post(
      `/api/ticket/work-tickets?${qs.stringify(payload)}`, {
        data,
        headers
      }
    )
    return [err, res]
  }
  // 获取扩展属性下拉列表
  static async getExtendClassList(payload) {
    const [err, res] = await superagentApi.get(
      `/api/std/StdClassExtendClass/get-list?${qs.stringify(payload)}`, {
        headers,
      }
    )
    return [err, res]
  }
  // 获取扩展属性数据
  static async getExtendData(data) {
    const [err, res] = await superagentApi.post('/api/std/StdClassExtendClass/get-extend-data', {
      data,
      headers,
    })
    return [err, res]
  }

  static async getInfo(data) {
    const [err, res] = await superagentApi.get(`/api/std/Tag/tags?${qs.stringify(data)}`, {
      headers,
    })
    return [err, res]
  }
  static async getViewPoint(data) {
    const [err, res] = await portalApi.get(`/api/view-point/get-view-point-priority-async?${qs.stringify(data)}`, {
      headers,
    })
    return [err, res]
  }
}
